import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";

export const keyToLabel = {
  tax: 'Accumulated Tax',
  extPrice: 'Accumulated Exact Price',
};

const stackStrategy = {
  // stack: 'total',
  area: true,
  // stackOffset: 'none',
};

const  months =  [
  { id: "1", key: 1, name: "Jan", label: "January" },
  { id: "2", key: 2, name: "Feb", label: "February" },
  { id: "3", key: 3, name: "March", label: "March" },
  { id: "4", key: 4, name: "April", label: "April" },
  { id: "5", key: 5, name: "May", label: "May" },
  { id: "6", key: 6, name: "June", label: "June" },
  { id: "7", key: 7, name: "July", label: "July" },
  { id: "8", key: 8, name: "Aug", label: "August" },
  { id: "9", key: 9, name: "Sept", label: "September" },
  { id: "10", key: 10, name: "Oct", label: "October" },
  { id: "11", key: 11, name: "Nov", label: "November" },
  { id: "12", key: 12, name: "Dec", label: "December" },
];

const SalesLineChart = ({ year, data }) => {

  console.log("data",data);

  return (
    <LineChart
      xAxis={[{ dataKey: 'month',           valueFormatter: (value) => months.find((_m)=>_m.key==value)?.label || "",      }]}
      yAxis={[{ label: `Accumulated Sales for year ${year}` }]}
      series={Object.keys(keyToLabel).map((key) => ({
        dataKey: key,
        label: keyToLabel[key],
        // color: colors[key],
        // showMark: false,
        ...stackStrategy,
      }))}
      dataset={data}
      height={300}
    />
  );
};

export default SalesLineChart;